<template>
  <div class="app-extend-filter-wrapper custom-wrapper">

    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item
          label="应用"
          prop="app_store_id"
          v-if="hasRes('store_app_index')" >
          <el-select
            filterable
            default-first-option
            v-model="filterForm.app_store_id" >
            <el-option label="全部" value="" />
            <el-option
              v-for="app in appList"
              :key="app.app_store_id"
              :label="app.app_name_i18n[0].name"
              :value="app.app_store_id" />
          </el-select>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="onFilterReset">重置</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'AppExtendFilter',
  data () {
    return {
      filterForm: {
        app_store_id: ''
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('store', [
      'getApps'
    ]),

    // 获取选择框下面的数据
    async getSelectDatas () {
      if (this.hasRes('store_app_index')) {
        try {
          this.getApps({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
    // 提交表单请求
    onFilterSubmit () {
      this.setPage(1)

      const filters = Object.assign({}, this.filterForm)
      filters.app_store_id === '' && delete filters.app_store_id
      this.setFilters(filters)
      this.$emit('filter')
    },
    // 重置表单
    onFilterReset () {
      this.$refs['filterForm'].resetFields()
      this.getSelectDatas()
    }
  },
  mounted () {
    this.getSelectDatas()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/AppExtendFilter.vue